import React from "react";

import "./stylesKpiCard.css";
import { Skeleton, Statistic } from "antd";
import CountUp from "react-countup";

function KpiCard({
  title,
  value,
  hugeValue,
  percentage,
  rate = false,
  backgroundColor,
  isApiRunning = false,
  customColor = false,
  customText = false,
  maximumFractionDigits = 2
}) {
  const formatter = (value) => (
    <CountUp end={value} separator="," decimal="." decimals={maximumFractionDigits} />
  );

  return (
    <div id="kpi-card" style={{ backgroundColor }}>
      {isApiRunning && <Skeleton active />}
      {!isApiRunning && (
        <>
          <div className="top">
            <h3>{title}</h3>
          </div>
          <div className="value-container">
            <p
              className={`value ${hugeValue ? "huge-value" : ""}`}
              style={customColor ? { color: customColor } : { color: "white" }}
            >
              {rate || maximumFractionDigits === 0 ? "" : "$"}{" "}
              <div className="statistic-value">
                <Statistic
                  value={value}
                  formatter={formatter}
                  valueStyle={
                    customColor ? { color: customColor } : { color: "white" }
                  }
                />
              </div>
              {rate ? "%" : ""}
              {/* {rate ? "" : "$"} {value} {rate ? "%" : ""} */}
            </p>
            {(percentage || percentage === 0) && (
              <p>
                {" "}
                <span
                  className="percentage"
                  style={
                    percentage >= 0
                      ? { color: "#71BF8A" }
                      : { color: "#E74C3C" }
                  }
                >
                  {percentage >= 0 ? "+ " : " "}{" "}
                  {Number(percentage).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: maximumFractionDigits,
                  })}
                  %
                </span>{" "}
                {customText === "" ? "" : customText ? customText : "vs last month"}
              </p>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default KpiCard;